import { Request, Response } from "express"

import { getFavorites, addFavorite, deleteFavorite } from "#services/user/favorites"

export const favoriteList = async (req: Request, res: Response) => {
	const list = await getFavorites({ userID: req.params.userID })

	res.json(list)
}

export const favoriteAdd = async (req: Request, res: Response) => {
	const list = await addFavorite({ userID: req.body.userID, recipeID: req.body.recipeID })

	res.json(list)
}

export const favoriteDelete = async (req: Request, res: Response) => {
	const list = await deleteFavorite({ userID: req.body.userID, recipeID: req.body.recipeID })

	res.json(list)
}
